// removed by extract-text-webpack-plugin
module.exports = {"mandatfordelingWidget":"nrk-v17-static-mandatfordelingWidget","margin10-15":"nrk-v17-static-margin10-15","large":"nrk-v17-static-large","mandatfordelingWidget__header":"nrk-v17-static-mandatfordelingWidget__header","mandatfordelingWidget__title":"nrk-v17-static-mandatfordelingWidget__title","mandatfordelingWidget__description":"nrk-v17-static-mandatfordelingWidget__description","mandatfordelingWidget__source":"nrk-v17-static-mandatfordelingWidget__source"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/containers/MandatfordelingWidget/style.css
// module id = 265
// module chunks = 0 1